module.exports = __webpack_public_path__ + "static/media/newLogo.9b13c3ef.png";